export default {
  auditParams: {
    include: 'entity,user,reviewer',
    limit: 20,
    page: 1,
    flag_id: null,
    entity: null,
    days: null
  },
  audits: [],
  auditsMeta: {},
  entry: null,
  comments: [],
  commentsMeta: {},
  commentsChildren: {},
  commentsChildrenMeta: {},
  unseens: []
};